import { render, staticRenderFns } from "./FoodEdit.vue?vue&type=template&id=3e59dd85&scoped=true&"
import script from "./FoodEdit.vue?vue&type=script&lang=js&"
export * from "./FoodEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e59dd85",
  null
  
)

export default component.exports